<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-justify">
        <h2 class="display-2 text-center text-secondary">Holoword (Beta Version)</h2>
        <p class="text-body-1">
          A Bothan researcher is exploring the depths of the Galactic Library, seeking hidden fragments of
          knowledge to enrich the Galactic Encyclopedia. Can you help uncover the secrets buried within? Use
          your intuition to find the secret word, and bring valuable data back to the galaxy! A new word every day!
        </p>
      </v-col>
    </v-row>
    <!-- Game Section -->
    <v-row justify="center">
    </v-row>
  </v-container>
</template>

<script>
import apiClient from "@/apiClient";
export default {
};
</script>